import { Navigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../Store/store';
import { logout } from '../../Slice/userSlice';
import { useEffect } from 'react';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const isLoggedIn = useAppSelector(state => state.user.isLoggedIn);
  const role = useAppSelector(state => state.user.role);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const token = localStorage.getItem('auth-token');
    if (!token && isLoggedIn) {
      dispatch(logout());
    }
  }, [isLoggedIn, dispatch]);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;